import { render } from "./InAppProductsListPropsCmp.vue?vue&type=template&id=23cafdf7"
import script from "./InAppProductsListPropsCmp.vue?vue&type=script&lang=js"
export * from "./InAppProductsListPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__